<template>
  <f7-page>
    settings
  </f7-page>
</template>

<script>
export default {
  name: 'SettingsPage'
}
</script>
